import { useState, useContext, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { url } from "../../utils/url";
import UserContext from "../../UserContext";

import "../../App.css";
import { CameraOutlined } from "@ant-design/icons";

export default function UpdateAvatarModal(props) {
  const [images, setimages] = useState([]);

  const { mode } = useContext(UserContext);
  const [dark, setDark] = useState(false);

  // upload image here

  const [file, setFile] = useState("");
  const [img, setImage] = useState("");
  let tempFile;
  const uploadImage = (e) => {
    tempFile = e.target.files[0];
    // console.log("img",tempFile)
    const reader = new FileReader();
    reader.addEventListener(
      "load",
      function () {
        setFile(reader.result);
        setImage(tempFile);
      },
      false
    );

    if (tempFile) {
      reader.readAsDataURL(tempFile);
    }
    //  console.log(tempFile)
    // setFilename(e.target.files.name);

    props.onHide();
  };

  useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);

  useEffect(() => {
    let tempImages = [];
    for (let i = 0; i < 40; i++) {
      const name = `/avatars/avatar-${i + 1}.png`;
      tempImages[i] = {
        name,
        id: i,
      };
    }
    setimages(tempImages);
    if (file) {
      props.handleavatar(file, img);
    }
  }, [file, props, img]);

  let thisAvatar = props.currentAvatar.includes("http")
    ? props.currentAvatar
    : url + props.currentAvatar;

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable="true"
      className={dark && "special_modal"}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter h6">
          <span className="text-md font-bold text-sm"> 🔥 Change Avatar</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center mx-auto">
        <h4 className="text-sm font-bold">Current Avatar</h4>
        <div className="flex gap-2">
          <img
            alt="current avatar"
            src={`${file ? file : thisAvatar}`}
            className="w-32 h-32 object-cover rounded-full"
          />

          <div className="flex">
            <label
              htmlFor="profile"
              className="flex gap-2 items-center cursor-pointer"
            >
              <div className="hommy--btn px-2 p-1 rounded">
                <CameraOutlined />
              </div>
            </label>
          </div>
          <input type="file" id="profile" onChange={uploadImage} hidden />
        </div>
        <hr />
        <h1 className="text-sm">Available Avatars</h1>
        <span className="font-bold">(Click on the avatar to select it)</span>
      <div className="w-full">
        <div className="w-full gap-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
          {images.map((item) => {
            return (
            <div className="w-28 h-28 bg-gray-100 rounded-full">
                <img
                height="150"
                alt={`avatar ${item.id + 1}`}
                src={`${url}${item.name}`}
                key={item.id}
                className="h-28 w-28 rounded-full object-cover border cursor-pointer"
                style={{ borderRadius: "50%" }}
                onDoubleClick={() => {
                  props.handleavatar(item.name);
                  setFile();
                  props.onHide();
                }}
                onClick={() => {
                  props.handleavatar(item.name);
                  setFile();
                  props.onHide();
                }}
              />
            </div>
            );
          })}
        </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {/* a bug to be fixed */}
        <button class="" onClick={props.onHide}>
          {/* Cancel */}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
